// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-title[data-v-dc8be39a] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n.text[data-v-dc8be39a] {\n    font-size: 18px;\n    font-weight: bold;\n    color: #303133;\n}\n}\n.dialog-content[data-v-dc8be39a] {\n.select-content[data-v-dc8be39a] {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n[data-v-dc8be39a] .el-form-item__label {\n    white-space: nowrap;\n}\n}\n", ""]);
// Exports
module.exports = exports;
